<template>
  <el-tooltip class="item primarna-barva" placement="top">
    <div slot="content">
      Elektronskemu naslovu lahko dodate želene psevdonime (aliase), <br>
      katere poimenujete po svojih željah (npr: janez_1@t-2.net), elektronsko <br>
      pošto na kateregakoli od teh psevdonimov pa boste prejemali v svoj <br>
      elektronski predal.
    </div>
    <el-icon class="el-icon-info">
    </el-icon>
  </el-tooltip>
</template>

<script>
  import {Tooltip} from 'element-ui'

  export default {
    name: 'Tolltip',
    components: {
      [Tooltip.name]: Tooltip
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/ElektronskaPosta/PsevdonimTooltip.vue